import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';

export const Root = styled.div`
  width: 100%;
`;

/** 342×133 @375 — banner.png (684×266 @2x) */
export const BannerImage = styled.img`
  display: block;
  width: 100%;
  ${r('height', 133)}
  object-fit: cover;
  object-position: center;
`;
